import * as types from './mutation-types'
export default {
  [types.SAVE_ALL_NOTIFICATIONS](state, data) {
    state.allNotifications = data
  },
}
